import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useRecoilState } from 'recoil';
import axios from '../../../plugins/axios';
import { useTranslation } from 'react-i18next'
import { wardState, bedInfoState, connectedBedsState, wardSuspendState, subMonitorValue1State, subMonitorValue2State, value1State, value2State, monitorState, bedSocketState } from '../../../plugins/recoil';
import DragDrop from './DragDrop';
import {ReactComponent as IconArrowUp} from '../../../assets/icons/ic-arrow-up.svg';
import {ReactComponent as IconArrowDown} from '../../../assets/icons/ic-arrow-down.svg';
import {ReactComponent as IconCheck} from '../../../assets/icons/ic-check_blue.svg';
import {ReactComponent as IconInit} from '../../../assets/icons/ic-init.svg';
import Toast from '../../../plugins/useToast';
import SetBedNumberSize from './Display/SetBedNumberSize';
import SetParameterColor from './Display/SetParameterColor';

function DisplaySettings({wardSetting, handleSaveHalfDashboard, onSave, onSaveSuccess,onUnassignComplete}) {
    const { t } = useTranslation()
    const [allDevices, setAllDevices] = useState([]);
    const [customBedConfig1, setCustomBedConfig1] = useState(true);
    const [customBedConfig2, setCustomBedConfig2] = useState(false);
    const [customBedConfig3, setCustomBedConfig3] = useState(false);
    const [wardSuspend, ] = useRecoilState(wardSuspendState);
    const [isDisabled, setIsDisabled] = useState(true); //저장버튼
    const [mainMonitorBedCount, setMainMonitorBedCount] = useState('16 Bed');
    const [subMonitorBedCount, setSubMonitorBedCount] = useState('16 Bed');
    const [activeTab, setActiveTab] = useState('leftTab1');
    const [curWard, ] = useRecoilState(wardState)
    const [value1, setValue1] = useRecoilState(value1State);
    const [value2, setValue2] = useRecoilState(value2State);
    const [subMonitorValue1, setSubMonitorValue1] = useRecoilState(subMonitorValue1State);
    const [subMonitorValue2, setSubMonitorValue2] = useRecoilState(subMonitorValue2State);
    const [connectedBeds, setConnectedBeds] = useRecoilState(connectedBedsState);
    const [curMonitor, setCurMonitor] = useRecoilState(monitorState)
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    // bedTextSize: 'LARGE' | 'SMALL' (wardSetting)
    // selectedRadio: 'LARGE' | 'NORMAL' (UI)
    const [selectedRadio, setSelectedRadio] = useState('');
    const dropdownRef = useRef(null);
    const options = [
        { value: '4 Bed', label: t('setting.countBed', { count: 4 }) },
        { value: '6 Bed', label: t('setting.countBed', { count: 6 }) },
        { value: '8 Bed', label: t('setting.countBed', { count: 8 }) },
        { value: '10 Bed', label: t('setting.countBed', { count: 10 }) },
        { value: '12 Bed', label: t('setting.countBed', { count: 12 }) },
        { value: '14 Bed', label: t('setting.countBed', { count: 14 }) },
        { value: '16 Bed', label: t('setting.countBed', { count: 16 }) },
        { value: 'custom', label: t('setting.custom') },
    ];

    // curMonitor에 해당하는 setting만 추출
    const monitorSetting = Array.isArray(wardSetting)
        ? wardSetting.find(setting => setting.displayOrder === curMonitor)
        : wardSetting;

    // monitorSetting이 없을 때 기본값
    const leftBedCount = monitorSetting?.leftBedCount || 8;
    const rightBedCount = monitorSetting?.rightBedCount || 8;
    const [leftBedCountState, setLeftBedCountState] = useState(monitorSetting?.leftBedCount || 8);
    const [rightBedCountState, setRightBedCountState] = useState(monitorSetting?.rightBedCount || 8);
    const devices = monitorSetting?.devices || [];

    //Rodney - paramterColors 
    const [parameterColors, setParameterColors] = useState([]);    
    const [selectParameterColors, setSelectParameterColors] = useState([]);
    const [defaultParameterColors, setDefaultParameterColors] = useState([]);
    const [isResetable, setIsResetable] = useState(false);    

    //색상을 선택하면 변경 할 수 있게.
    const handleSelectColors = (type, code, value) => {                
        setSelectParameterColors(prev => {
            if (type === 'wave') {
                return {
                    ...prev,
                    waveParameterColors: {
                        ...prev.waveParameterColors,
                        [code]: { ...prev.waveParameterColors[code], color : value }
                    }
                };
            } else if (type === 'numeric') {
                return {
                    ...prev,
                    numericParameterColors: {
                        ...prev.numericParameterColors,
                        [code]: { ...prev.numericParameterColors[code], color : value }
                    }
                };
            }
            return prev;
        });
        setIsDisabled(false); // 상태 변경 시 저장 버튼 활성화
    };

    //parameterColors Settings
    const handleSetColors = async () => {
        //현재 사용하고 있는 wave 및 numeric parameter 코드 및 색상 가져오기. (default)
        const waveRes = await axios.get('/measure/parameters/wave');
        if( waveRes.code !== 200) throw waveRes;        

        const numericRes = await axios.get('/measure/parameters/numeric');
        if( numericRes.code !== 200) throw numericRes;

        //Reset을 위해 Default로 들고 있는 파라미터 색상 및 Label을 재 정렬.
        const waveResDafault = waveRes.data.parameters
            .filter(param => param.parameter !== 'NONE')
            .map(param => ({
                measureParameterId: param.id,
                measureParameter: param.parameter,
                label: param.label,
                color: param.color
            }));

        const numericResDefault = numericRes.data.parameters
        .filter(param => param.parameter !== 'NONE')
        .map(param => ({
            measureParameterId: param.id,
            measureParameter: param.parameter,
            label: param.label,
            color: param.color
        }));        

        // 기준 배열의 순서를 정렬 해야 되기 때문에 default로 들고 있는 순서를 변수로 체크함. 
        const waveOrder = waveRes.data.parameters.map(param => param.parameter);
        const numericOrder = numericRes.data.parameters.map(param => param.parameter);        

        //만약에 moinitorSetting의 데이터가 없다면? default 데이터 넣어주기
        let waveParameterColors;
        let numericParameterColors;

        if (Array.isArray(monitorSetting?.waveParameterColors) && monitorSetting?.waveParameterColors.length > 0 && Array.isArray(monitorSetting?.numericParameterColors) && monitorSetting?.numericParameterColors.length > 0) {            
            waveParameterColors = monitorSetting.waveParameterColors.filter(param => param.measureParameter !== 'NONE');
            numericParameterColors = monitorSetting.numericParameterColors.filter(param => param.measureParameter !== 'NONE');
        }else{
            // NONE은 바꿀 필요가 없어서 제거
            waveParameterColors = waveResDafault;
            numericParameterColors = numericResDefault;
        }

        // MonitorSetting에서 가져온 파라미터 색상과 label을 기준으로 정렬
        waveParameterColors = waveParameterColors.sort(
            (a, b) => waveOrder.indexOf(a.measureParameter) - waveOrder.indexOf(b.measureParameter)
        );
        numericParameterColors = numericParameterColors.sort(
            (a, b) => numericOrder.indexOf(a.measureParameter) - numericOrder.indexOf(b.measureParameter)
        );

        //parameterColors[key]로 사용하기 위해 세팅 
        const waveParameterColorsMap = waveParameterColors
            .reduce((acc, cur) => {
                acc[cur.measureParameter] = cur;
                return acc;
        }, {});

        const numericParameterColorsMap = numericParameterColors
            .reduce((acc, cur) => {
                acc[cur.measureParameter] = cur;
                return acc;
        }, {});

        //더미 데이터 넣기
        setParameterColors({waveParameterColors : waveParameterColors, numericParameterColors : numericParameterColors});
        setSelectParameterColors({waveParameterColors : waveParameterColorsMap, numericParameterColors : numericParameterColorsMap});
        setDefaultParameterColors({waveParameterColors : waveResDafault,numericParameterColors : numericResDefault});
    }

     // 파라미터 초기화 버튼 클릭 핸들러 
    const handleParameterReset = () => {
        const deepCopyAndMap = (list = []) => {
            const copiedList = list.map(item => ({ ...item }));
            const mapped = copiedList.reduce((acc, cur) => {
                acc[cur.measureParameter] = { ...cur };
                return acc;
            }, {});
            return [copiedList, mapped];
        };

        const [waveList, waveMap] = deepCopyAndMap(defaultParameterColors.waveParameterColors);
        const [numericList, numericMap] = deepCopyAndMap(defaultParameterColors.numericParameterColors);

        setParameterColors({
            waveParameterColors: waveList,
            numericParameterColors: numericList
        });
        setSelectParameterColors({
            waveParameterColors: waveMap,
            numericParameterColors: numericMap
        });
        setIsDisabled(false); 
    };

    //Reset 버튼 체크 하는 useEffect
    useEffect(() => {
        const isDifferent = (defaultList, selectedMap) => {
            if (!Array.isArray(defaultList) || !selectedMap) return false;

            return defaultList.some(({ measureParameter, color }) => {
                const selectedColor = selectedMap[measureParameter]?.color;
                return color !== undefined && selectedColor !== undefined && color !== selectedColor;
            });
        };

        const resetable =
            isDifferent(defaultParameterColors.waveParameterColors, selectParameterColors.waveParameterColors) ||
            isDifferent(defaultParameterColors.numericParameterColors, selectParameterColors.numericParameterColors);

        setIsResetable(resetable);
    }, [selectParameterColors]);

    useEffect(() => {
        handleSetColors(); //Parameter Colors Settings       

        const totalBeds = leftBedCount + rightBedCount;
        const isBalanced = leftBedCount === rightBedCount;
    
        // monitorSetting이 없거나 bedCount가 0이면 16Bed 기본값
        if (!monitorSetting || totalBeds === 0) {
            setCustomBedConfig1(false);
            setMainMonitorBedCount('16 Bed');
            setSelectedRadio('NORMAL');
            return;
        }
    
        let radio = 'NORMAL';
        if (monitorSetting.bedTextSize === 'LARGE') radio = 'LARGE';
        else if (monitorSetting.bedTextSize === 'SMALL') radio = 'NORMAL';
        setSelectedRadio(radio);

        // options에서 해당 배드 수와 매칭되는 옵션 찾기
        const matchingOption = options.find(
            option => parseInt(option.value.split(" ")[0], 10) === totalBeds
        );

        if (matchingOption && isBalanced && mainMonitorBedCount != 'Custom') {
            setCustomBedConfig1(false);
            setMainMonitorBedCount(matchingOption.value);
        } else {
            setCustomBedConfig1(true);
            setMainMonitorBedCount('Custom');
        }
    }, [monitorSetting, leftBedCount, rightBedCount, curMonitor]);

    // deviceId별 monitorNumbers[] 맵 생성 (항상 wardSetting 전체로)
    const deviceMonitorMap = useMemo(() => {
        const map = {};
        if (Array.isArray(wardSetting)) {
            wardSetting.forEach(setting => {
                (setting.devices || []).forEach(device => {
                    if (!map[device.deviceId]) map[device.deviceId] = [];
                    if (!map[device.deviceId].includes(setting.displayOrder)) {
                        map[device.deviceId].push(setting.displayOrder);
                    }
                });
            });
        }
        return map;
    }, [wardSetting]);    

    useEffect(() => {        
        const fetchDevices = async () => {
            try {                                
                const res = await axios.get(`/devices?wardId=${curWard.value}`);
                setAllDevices(res.data.content || []);
            } catch (error) {
                console.error(error);
            }
        };
        fetchDevices();
    }, []);

    useEffect(() => {
        if (!allDevices.length) {
            setConnectedBeds([]);
            return;
        };

        const usedDeviceIds = [
            ...value1.map(bed => bed.deviceId),
            ...value2.map(bed => bed.deviceId),
        ];
        const getPatientName = (deviceId) => {
            const bed = [...value1, ...value2].find(b => b.deviceId === deviceId);
            return bed ? bed.patientName : '';
        };
        let removedBeds = allDevices.map(device => {
            const isUsed = usedDeviceIds.includes(device.id);
            // deviceMonitorMap의 key는 device.id로 접근해야 함
            const monitorNumbers = deviceMonitorMap[device.id] || [];
            return {
                ...device,
                isRemoved: !isUsed,
                deviceId: device.id,
                monitorNumbers,
                patientName: getPatientName(device.id) || device.patientName || ' - ',
            };
        });
        removedBeds = removedBeds.sort((a, b) => Number(a.deviceId) - Number(b.deviceId));
        setConnectedBeds(removedBeds.sort((a, b) => {
            const aid = a.deviceId || a.id || 0;
            const bid = b.deviceId || b.id || 0;
            return Number(aid) - Number(bid);
        }));
    }, [value1, value2, allDevices, deviceMonitorMap, curMonitor]);

    useEffect(() => {
        if (monitorSetting && leftBedCountState + rightBedCountState > 0) {
            const totalBeds = leftBedCountState + rightBedCountState;
            // 1. bedCount만큼 빈 배열 생성
            const bedsArr = Array(totalBeds).fill(null);

            // 2. monitorSetting.devices의 displayOrder에 맞게 해당 인덱스에 배치
            devices.forEach(device => {
                if (device.displayOrder > 0 && device.displayOrder <= totalBeds) {
                    bedsArr[device.displayOrder - 1] = device;
                }
            });

            // 3. value1, value2로 분리 (빈 칸은 빈 객체로)
            const value1Beds = bedsArr.slice(0, leftBedCountState).map(bed => bed || { bedNumber: '', deviceId: '' });
            const value2Beds = bedsArr.slice(leftBedCountState, totalBeds).map(bed => bed || { bedNumber: '', deviceId: '' });

            setValue1(value1Beds);
            setValue2(value2Beds);
        }
    }, []);

    // 드래그 앤 드롭이나 구성 변경에 따른 상태 업데이트 시 저장 버튼 활성화 로직
    const handleStateChange = (setter) => (...args) => {
        setter(...args);
        setIsDisabled(false); // 상태 변경 시 저장 버튼 활성화
    };

    const handleSave =  async () => {

        // 빈 배드의 displayOrder를 자동으로 할당
        const assignDisplayOrder = (list, startOrder) => {
            return list.map((bed, index) => ({
                ...bed,
                displayOrder: bed.displayOrder || index + startOrder,
            }));
        };
        // value1과 value2에 displayOrder 자동 할당
        const updatedValue1 = assignDisplayOrder(value1, 1); // 1부터 시작
        const updatedValue2 = assignDisplayOrder(value2, updatedValue1.length + 1); // value1 다음부터 시작

        // 상태 업데이트
        setValue1(updatedValue1);
        setValue2(updatedValue2);
        const allBeds = [...updatedValue1, ...updatedValue2];
        allBeds.sort((a, b) => a.displayOrder - b.displayOrder);
        
        //Rodney - Custom으로 체크되어있으면 기존 Option에 있는 display Option으로 강제 변경 되지 않게 수정.
        let matchingOption = false;

        if(mainMonitorBedCount != 'Custom'){
            const totalBeds = updatedValue1.length + updatedValue2.length;
    
            matchingOption = options.find(
                (option) => parseInt(option.value.split(" ")[0], 10) === totalBeds
            );   
        }
            
        const newBedInfo = [...updatedValue1, ...updatedValue2].map((bed) => ({
            ...bed,
            suspended: wardSuspend === "1" ? "1" : "0",
            alarmSilence: wardSuspend === "2" ? "1" : "0",
            bedNumber: bed.bedNumber || "", // 빈 배드의 bedNumber 유지
            patientId: bed.patientId || "", // 빈 배드의 patientId 유지
            displayOrder: bed.displayOrder || 0, // displayOrder가 없으면 기본값으로 0 설정
            vsmMode: bed.vsmMode || '0'
        }));

        if (matchingOption) {
            setMainMonitorBedCount(matchingOption.value); // 매칭된 옵션 값으로 mainMonitorBedCount 설정
            setCustomBedConfig1(false);
        } else {
            setMainMonitorBedCount('Custom'); // 값이 균형 맞지 않으면 사용자 지정으로 설정
            setCustomBedConfig1(true);
        }

        const newCnt = [];
        [updatedValue1.length, updatedValue2.length].forEach((num) => {
            switch(num) {
                case 8: newCnt.push(...[4, 4]); break;
                case 7: newCnt.push(...[4, 3]); break;
                case 6: newCnt.push(...[3, 3]); break;
                case 5: newCnt.push(...[3, 2]); break;
                case 4: newCnt.push(...[2, 2]); break;
                case 3: newCnt.push(...[2, 1]); break;
                case 2: newCnt.push(...[1, 1]); break;
                default: break;
            }
        })
        const newValue = '1';
        handleSaveHalfDashboard(newBedInfo, newCnt);
        onSave(newValue);

         // Recoil 상태 및 로컬 스토리지 업데이트
        const bedConfig = {
            value1: updatedValue1,
            value2: updatedValue2,
            // subMonitorValue1,
            // subMonitorValue2,
            connectedBeds,
        };
        localStorage.setItem('bedConfig', JSON.stringify(bedConfig));
        localStorage.setItem('newBedInfo', JSON.stringify(newBedInfo));
        setIsDisabled(true); // 저장 후 버튼 비활성화
        setConnectedBeds(connectedBeds);
        
        const wardBedLayoutList = newBedInfo.map((bed, index) => ({
            patientId: bed.patientId || "",
            bedNumber: bed.bedNumber || "",
            displayOrder: index + 1,
            name: bed.name || "",
            wardCode: curWard.value,
            wardName: "중환자실",
            suspended: wardSuspend === "1" ? "1" : "0",
            alarmSilence: wardSuspend === "2" ? "1" : "0",
        }));
        localStorage.setItem('bedConfig', JSON.stringify({ value1: updatedValue1, value2: updatedValue2 }));
        localStorage.setItem('wardBedLayoutList', JSON.stringify(wardBedLayoutList));

        const devicesRaw = newBedInfo
            .map((bed, idx) => ({
                deviceId: bed.deviceId !== undefined && bed.deviceId !== null && bed.deviceId !== "" ? bed.deviceId : null,
                displayOrder: idx + 1
            }))
            .filter(device => device.deviceId !== null && device.deviceId !== "");
        // deviceId 기준 중복 제거
        const devices = [];
        const seenDeviceIds = new Set();
        for (const device of devicesRaw) {
            if (!seenDeviceIds.has(device.deviceId)) {
                devices.push(device);
                seenDeviceIds.add(device.deviceId);
            }
        }

        //setSelectParameterColors
        //selectParameterColors

        const waveParameterColors = Object.values(selectParameterColors.waveParameterColors).map((item) => ({            
            measureParameterId: item.measureParameterId,
            color: item.color,
            label: item.label
        }));

        const numericParameterColors = Object.values(selectParameterColors.numericParameterColors).map((item) => ({            
            measureParameterId: item.measureParameterId,
            color: item.color,
            label: item.label
        }));        

        const putPayload = {
            displayOrder: curMonitor ? curMonitor : 1,
            leftBedCount: updatedValue1.length,
            rightBedCount: updatedValue2.length,
            bedTextSize: selectedRadio === 'NORMAL' ? 'SMALL' : 'LARGE',
            waveParameterColors: waveParameterColors,
            numericParameterColors: numericParameterColors,
            devices
        };        

        try {
            const saveRes = await axios.put(`/ward/${curWard.value}/dashboard/setting/${curMonitor ? curMonitor : 1}`, putPayload);
            if (saveRes.code !== 200) throw saveRes;

            // 저장 후 UI 업데이트 및 상태 초기화
            handleSaveHalfDashboard(newBedInfo, newCnt);
            onSave('1');
            setIsDisabled(true);
            if (onSaveSuccess) {
                onSaveSuccess();
                Toast({ isSuccess: true });
            }
        } catch (error) {
            Toast({ isSuccess: false , msg : error });
            console.error(error);
        }
    };

    //Bed Type 드롭다운 외부 클릭 시 닫기 이벤트
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };
            document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (!customBedConfig2) {
            setConnectedBeds(prev => {
                // 서브모니터 배드를 제거
                return prev.filter(
                    bed => !subMonitorValue1.some(subBed => subBed.id === bed.id) && !subMonitorValue2.some(subBed => subBed.id === bed.id)
                );
            });
        }
    }, [customBedConfig2, subMonitorValue1, subMonitorValue2]);
    
    useEffect(() => {
        if (customBedConfig1) return; // 사용자 설정 배드 구성이 꺼져 있으면 무시
    
        const totalBeds = parseInt(mainMonitorBedCount.split(" ")[0]); // mainMonitorBedCount 값에서 숫자 추출
        const bedsPerColumn = Math.floor(totalBeds / 2); // 두 열로 나누기
        const extraBeds = totalBeds % 2; // 나머지 배드는 두 번째 열에 추가
    
        // 기존값을 추출해 필요 없는 배드를 connectedBeds로 옮김
        const removedBeds1 = value1.slice(bedsPerColumn); // value1에서 남는 배드를 추출
        const removedBeds2 = value2.slice(bedsPerColumn + extraBeds); // value2에서 남는 배드를 추출
        const removedBeds = [...removedBeds1, ...removedBeds2].filter(bed => bed.patientId); // 유효한 배드만 추출
    
        // connectedBeds 배열에 남는 배드를 추가, 기존 중복되는 배드 제거
        setConnectedBeds((prevConnectedBeds) => {
            const filteredBeds = prevConnectedBeds.filter(bed => !removedBeds.some(removedBed => removedBed.patientId === bed.patientId));
            return [
                ...filteredBeds, 
                ...removedBeds.map(bed => ({ ...bed, isRemoved: true })) // 삭제된 배드를 연결된 배드로 추가, isRemoved: true로 설정
            ];
        });
    
        // 새로운 배열을 만들어 배드 수를 조정
        const newValue1 = value1.slice(0, bedsPerColumn);
        const newValue2 = value2.slice(0, bedsPerColumn + extraBeds);
    
        // 필요한 경우 빈칸 추가
        while (newValue1.length < bedsPerColumn) {
            newValue1.push({ bedNumber: '', patientId: '' });
        }
        while (newValue2.length < bedsPerColumn + extraBeds) {
            newValue2.push({ bedNumber: '', patientId: '' });
        }
    
        setValue1(newValue1);
        setValue2(newValue2);
    }, [mainMonitorBedCount, customBedConfig1]); // mainMonitorBedCount 또는 customBedConfig1 값이 변경될 때 실행

    // 왼쪽 칸 개수 조정
    useEffect(() => {
        if (!customBedConfig1) return;
        setValue1(prev => {
            const arr = prev.slice(0, leftBedCountState);
            while (arr.length < leftBedCountState) arr.push({ bedNumber: '', deviceId: '' });
            return arr;
        });
    }, [leftBedCountState, customBedConfig1]);

    // 오른쪽 칸 개수 조정
    useEffect(() => {
        if (!customBedConfig1) return;
        setValue2(prev => {
            const arr = prev.slice(0, rightBedCountState);
            while (arr.length < rightBedCountState) arr.push({ bedNumber: '', deviceId: '' });
            return arr;
        });
    }, [rightBedCountState, customBedConfig1]);
    
    useEffect(() => {
        if (customBedConfig3) return; // 사용자 설정 배드 구성이 꺼져 있으면 서브 모니터 배드 변경 무시
    
        const updateLayout = (totalBeds, subMonitorValue1, subMonitorValue2, setSubMonitorValue1, setSubMonitorValue2) => {
            const bedsPerColumn = Math.floor(totalBeds / 2);
            const extraBeds = totalBeds % 2;
            const removedSubMonitorValue1 = subMonitorValue1.slice(bedsPerColumn);
            const removedSubMonitorValue2 = subMonitorValue2.slice(bedsPerColumn + extraBeds);
    
            setConnectedBeds(prev => {
                const updatedConnectedBeds = [...prev];
                const filteredBeds = updatedConnectedBeds.filter(bed => !removedSubMonitorValue1.find(rBed => rBed.id === bed.id) && !removedSubMonitorValue2.find(rBed => rBed.id === bed.id));
                const newConnectedBeds = [
                    ...filteredBeds,
                    ...removedSubMonitorValue1.map(bed => ({ ...bed, isRemoved: true })),
                    ...removedSubMonitorValue2.map(bed => ({ ...bed, isRemoved: true })),
                ];
                return newConnectedBeds;
            });
    
            const newValue1 = subMonitorValue1.slice(0, bedsPerColumn);
            const newValue2 = subMonitorValue2.slice(0, bedsPerColumn + extraBeds);
    
            while (newValue1.length < bedsPerColumn) {
                newValue1.push({ id: '', ward: '' });
            }
            while (newValue2.length < bedsPerColumn + extraBeds) {
                newValue2.push({ id: '', ward: '' });
            }
    
            setSubMonitorValue1(newValue1);
            setSubMonitorValue2(newValue2);
        };
    
        const totalSubMonitorBeds = parseInt(subMonitorBedCount.split(" ")[0]);
        updateLayout(totalSubMonitorBeds, subMonitorValue1, subMonitorValue2, setSubMonitorValue1, setSubMonitorValue2);
    
    }, [subMonitorBedCount, customBedConfig3]);

    return (
        <div className="w-full h-full relative bg-[#1F1F1F] text-[#DEDEDE]">
            <div className="flex h-full">
                <div className="w-[284px] bg-[#2F2F2F] p-3">
                    <ul className="space-y-2 text-lg">
                        <li onClick={() => setActiveTab('leftTab1')} className={`pl-3 cursor-pointer h-[40px] flex items-center px-2 text-[#CECECE] ${activeTab === 'leftTab1' ? 'bg-[#1F1F1F] text-[#fff] border-l-[2px] border-[#3182F7] rounded-r-md' : ''}`}>
                            {t('setting.screen')}</li>
                        {/* Bed Number Size 탭 비활성화 */}
                        <li  
                        onClick={() => setActiveTab('leftTab2')}
                        className={`pl-3 cursor-pointer h-[40px] flex items-center px-2 text-[#CECECE] ${activeTab === 'leftTab2' ? 'bg-[#1F1F1F] text-[#fff] border-l-[2px] border-[#3182F7] rounded-r-md' : ''}`}>
                            {t('setting.setBedNumberSize')}</li>
                        <li  
                        onClick={() => setActiveTab('leftTab3')}
                        className={`pl-3 cursor-pointer h-[40px] flex items-center px-2 text-[#CECECE] ${activeTab === 'leftTab3' ? 'bg-[#1F1F1F] text-[#fff] border-l-[2px] border-[#3182F7] rounded-r-md' : ''}`}>
                            {t('setting.parameterColor')}</li>
                        {/* <li
                        onClick={() => setActiveTab('leftTab3')} 
                        className={`whitespace-nowrap pl-3 cursor-pointer h-[40px] flex items-center px-2 text-[#CECECE] ${activeTab === 'leftTab3' ? 'bg-[#1F1F1F] text-[#fff] border-l-[2px] border-[#3182F7] rounded-r-md' : ''}`}>
                            12 LEAD / Disconnected Data</li> */}
                    </ul>
                </div>

                <div className='w-full py-5 h-full scrollbar pl-[20px]'>
                    {activeTab === 'leftTab1' && <p className="mb-[16px] text-[18px] font-normal leading-[110%]">{t('setting.screenSettings')}</p>}
                    <div className="flex gap-4 min-h-[376px]" style={{height:'376px'}}>
                        {activeTab === 'leftTab1' && (
                            <>
                                <div className="bg-[#2F2F2F] p-4 rounded-md w-[258px]">
                                    <div className="mb-4">
                                        <label className="block mb-[16px] text-white text-[16px]">{t('setting.type')}</label>
                                        <div className="relative" ref={dropdownRef}>
                                            <div
                                                className={`!font-light pr-10 appearance-none w-full p-2 h-[32px] rounded-[6px] bg-gradient-to-b from-[#5E5E5E] to-[#383838] border border-[#5E5E5E] text-white cursor-pointer flex justify-between items-center`}
                                                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                                            >
                                                {customBedConfig1 ? 'Custom' : mainMonitorBedCount}
                                                <div className="absolute transform -translate-y-1/2 pointer-events-none top-1/2 right-2">
                                                {isDropdownOpen ? <IconArrowUp /> : <IconArrowDown />}
                                                </div>
                                            </div>
                                            {isDropdownOpen && (
                                                <ul className="!font-light absolute w-full mt-1 bg-[#1F1F1F] border border-[#5E5E5E] rounded-[6px] z-10 overflow-hidden py-[8px]">
                                                {options.map((option) => (
                                                    <li
                                                    key={option.value}
                                                    className={`h-[32px] py-[7px] px-[8px] hover:bg-[#2f2f2f] cursor-pointer flex justify-between items-center ${
                                                        (customBedConfig1 && option.value === 'custom') || (!customBedConfig1 && option.value === mainMonitorBedCount)
                                                            ? 'text-[#3182F7]' // 현재 선택된 옵션에 파란색 텍스트 스타일 추가
                                                            : ''
                                                    }`}
                                                    onClick={() => {
                                                        const value = option.value;
                                                        if (value === 'custom') {
                                                        handleStateChange(setCustomBedConfig1)(true);
                                                        } else {
                                                        handleStateChange(setCustomBedConfig1)(false);
                                                        handleStateChange(setMainMonitorBedCount)(value);

                                                        const totalBeds = parseInt(value.split(" ")[0], 10);
                                                        const left = Math.ceil(totalBeds / 2);
                                                        const right = Math.floor(totalBeds / 2);

                                                        setLeftBedCountState(left);
                                                        setRightBedCountState(right);
                                                
                                                        setValue1(prev => {
                                                            const arr = [...prev].slice(0, left);
                                                            while (arr.length < left) arr.push({ bedNumber: '', deviceId: '' });
                                                            return arr;
                                                        });
                                                        setValue2(prev => {
                                                            const arr = [...prev].slice(0, right);
                                                            while (arr.length < right) arr.push({ bedNumber: '', deviceId: '' });
                                                            return arr;
                                                        });
                                                        }
                                                        setIsDropdownOpen(false);
                                                    }}
                                                    >
                                                    {option.label}
                                                    {((customBedConfig1 && option.value === 'custom') || (!customBedConfig1 && option.value === mainMonitorBedCount)) && (
                                                        <IconCheck className="w-4 h-4 text-[#3182F7]" />
                                                    )}
                                                    </li>
                                                ))}
                                                </ul>
                                            )}
                                            </div>
                                    </div>
                                </div>
                                <DragDrop
                                    value1={value1}
                                    setValue1={handleStateChange(setValue1)}
                                    value2={value2}
                                    setValue2={handleStateChange(setValue2)}
                                    subMonitorValue1={subMonitorValue1}
                                    setSubMonitorValue1={handleStateChange(setSubMonitorValue1)}
                                    subMonitorValue2={subMonitorValue2}
                                    setSubMonitorValue2={handleStateChange(setSubMonitorValue2)}
                                    connectedBeds={connectedBeds ? [...connectedBeds].sort((a, b) => {
                                        const aid = a.deviceId || a.id || 0;
                                        const bid = b.deviceId || b.id || 0;
                                        return Number(aid) - Number(bid);
                                    }) : []}
                                    setConnectedBeds={handleStateChange(setConnectedBeds)}
                                    customBedConfig1={customBedConfig1}
                                    customBedConfig2={customBedConfig2}
                                    customBedConfig3={customBedConfig3}
                                    mainMonitorBedCount={mainMonitorBedCount}
                                    onUnassignComplete={onUnassignComplete}
                                    monitorSetting={monitorSetting}
                                    onBedCountChange={(column, diff) => {
                                        if (!monitorSetting) return;
                                        if (column === 'left') {
                                            if (monitorSetting.leftBedCount > 2) monitorSetting.leftBedCount += diff;
                                        } else if (column === 'right') {
                                            if (monitorSetting.rightBedCount > 2) monitorSetting.rightBedCount += diff;
                                        }
                                    }}
                                    leftBedCount={leftBedCountState}
                                    rightBedCount={rightBedCountState}
                                    setLeftBedCount={setLeftBedCountState}
                                    setRightBedCount={setRightBedCountState}
                                />
                            </>
                        )}
                        {activeTab === 'leftTab2' && <SetBedNumberSize selectedRadio={selectedRadio} setSelectedRadio={handleStateChange(setSelectedRadio)} />}
                        {activeTab === 'leftTab3' && <SetParameterColor parameterColors={parameterColors} selectParameterColors={selectParameterColors} handleSelectColors={handleSelectColors}/>}
                    </div>
                </div>
            </div>
            {
                activeTab === 'leftTab3' && (
                    <button className={`w-[88px] h-[28px] pr-5 absolute top-[-35px] right-[120px] rounded-[6px] font-light
                            ${!isResetable? 'bg-[#282828] text-[rgba(255,255,255,0.2)] cursor-default shadow-none'
                            : ' text-white bg-gradient-to-b from-[#5E5E5E] to-[#383838] shadow-md transition-all duration-200'}
                            active:from-[#4A4A4A] active:to-[#2B2B2B] active:shadow-sm`}            
                        onClick={() => handleParameterReset()}
                    >
                        {t('setting.reset')}
                        <span className="absolute right-3 top-[4px]" style={{ opacity: isResetable ? 1 : 0.3 }}>
                            <IconInit />
                        </span>
                    </button>
                )
            }
            
            <button className={`w-[88px] h-[28px] absolute top-[-35px] right-[20px] rounded-[6px] 
                    ${isDisabled? 'bg-[#1f1f1f] text-[rgba(255,255,255,0.2)] cursor-default shadow-none'
                    : 'text-white bg-gradient-to-b from-[#5E5E5E] to-[#383838] shadow-md transition-all duration-200'}
                    active:from-[#4A4A4A] active:to-[#2B2B2B] active:shadow-sm`}
                disabled={isDisabled}
                onClick={handleSave}
                >{isDisabled ? t('setting.saved') : t('setting.save')}
            </button>
        </div>
    );
}

export default DisplaySettings;